define('modules/page_generator/views/variant_item',['require','exports','module','base/itemview','lib/util','ldsh!../templates/variant_item'],function(require, exports, module){
  "use strict";

  var ItemView = require("base/itemview"),
    util = require("lib/util");

  module.exports = ItemView.extend({
    template: require("ldsh!../templates/variant_item"),
    tagName: "li",
    triggers: {
      "click a": "variant:select"
    },
    initialize: function(options){
      this.pageId = options.parent.pageId;
    },
    helpers: function(){
      return {
        pageId: this.pageId,
        platformIcon: util.getVariantIcon(this.model.get('platform'))
      };
    },
    onRender: function(){
      this.$el.data("variant-id", this.model.id);
    }
  });
});

